/* New showroom (Sector 86) — the browser's copy of the "Opening … ends after the opening date"
   check. Liquid already decides this on every request (snippets/kf-nsr.liquid); this only matters
   for a page that was cached before the date passed. An element carrying data-kf-nsr-until
   (seconds since 1970) is removed once that moment is gone — or, if it also carries
   data-kf-nsr-flip, turned into that text (the Locations badge becomes "Open Now"). */
(function () {
  if (window.__kfNsr) return;
  window.__kfNsr = true;
  function run() {
    var now = Math.floor(Date.now() / 1000);
    var els = document.querySelectorAll('[data-kf-nsr-until]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], until = parseInt(el.getAttribute('data-kf-nsr-until'), 10);
      if (!until || now <= until) continue;
      var flip = el.getAttribute('data-kf-nsr-flip');
      if (flip) {
        el.classList.remove('kf-lx-badge-soon');
        el.removeAttribute('data-kf-nsr-until');
        el.removeAttribute('data-kf-nsr-flip');
        el.textContent = '';
        var dot = document.createElement('span');
        dot.className = 'kf-lx-dot';
        el.appendChild(dot);
        el.appendChild(document.createTextNode(flip));
      } else if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
